"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

var _sizes = require("HubStyleTokens/sizes");

var _misc = require("HubStyleTokens/misc");

var _Styles = require("../../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  ", ";\n  text-transform: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var H6 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H6",
  componentId: "awwkw8-0"
})(_templateObject(), _Styles.FONT_FAMILIES[_misc.HEADING_WEIGHT6], (0, _Styles.setFontSize)(_sizes.HEADING6), _misc.HEADING_CASE6);
H6.propTypes = (0, _extends2.default)({}, _Heading.default.propTypes);
H6.defaultProps = (0, _extends2.default)({}, _Heading.default.defaultProps, {
  tagName: 'h6'
});
H6.displayName = 'H6';
var _default = H6;
exports.default = _default;
module.exports = exports.default;